import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const AuthImage = ({ fileId, alt, className, testid }) => {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let url;
    api.get(`/files/${fileId}`, { responseType: "blob" }).then((r) => {
      url = URL.createObjectURL(r.data);
      setSrc(url);
    }).catch(() => {});
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [fileId]);
  return src ? <img src={src} alt={alt} className={className} data-testid={testid} /> : <div className={`${className} animate-pulse bg-slate-100`} />;
};
